var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { recursiveMergeObjects } from './recursive-merge-objects';
export var getRefreshedPermissions = function (_a) {
    var currentPermissions = _a.currentPermissions, newPermissions = _a.newPermissions, withRecursiveMerge = _a.withRecursiveMerge;
    // делаем список всех скоупов и убираем дубликаты
    var scopesUniqueList = __spreadArray([], __read(new Set(Object.keys(newPermissions).concat(Object.keys(currentPermissions)))), false);
    // сливаем прежние с новыми
    return scopesUniqueList.reduce(function (acc, scope) {
        var _a;
        var currentScopePermissions = currentPermissions[scope] || {};
        var newScopePermissions = newPermissions[scope] || {};
        return __assign(__assign({}, acc), (_a = {}, _a[scope] = withRecursiveMerge
            ? recursiveMergeObjects(currentScopePermissions, newScopePermissions)
            : __assign(__assign({}, currentScopePermissions), newScopePermissions), _a));
    }, {});
};
